module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f07417_banner_800x600.04fbb150.png";